import React, { useState } from 'react';
// DatePicker
import { DatePicker } from '../ui/DatePicker';
// CSS
import './Timecard.css';
import './TimecardStatus.css';
import "react-datepicker/dist/react-datepicker.css";
// 日付のテンプレート文字列をインポート
import { stringToDate, dateToString } from '../../utils/utils';
import RippleButton from '../ui/rippleButton'

type Props = {
  date: string,
  updateDate: (date:Date) => void;
  onClose: () => void;
}

const TimecardStatus: React.FC<Props> = ({date, updateDate, onClose}) => {

  const [datepickerDate, setDatepickerDate] = useState(date);  // DatePicker日時テキスト
  const [selectedDate] = useState(new Date(date));
  
  // 時間の初期値テンプレート
  const formatInitialTime = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, '0')}`;
  }

  // 日付変更を検知
  const handleDateFormChange = (date: Date, setTime: React.Dispatch<React.SetStateAction<string>>) => {
    setTime(dateToString(date));
    selectedDate.setFullYear(date.getFullYear());
    selectedDate.setMonth(date.getMonth());
    selectedDate.setDate(date.getDate());
    selectedDate.setSeconds(0);
  };
  // 時間変更を検知
  const handleTimeFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedTime = e.target.value.split(":");
    selectedDate.setHours(Number(selectedTime[0]));
    selectedDate.setMinutes(Number(selectedTime[1]));
    selectedDate.setSeconds(0);
  }
  // 登録処理
  const registrationDate = () => {
    updateDate(selectedDate);
    onClose();
  }

  return(
    <div>
      <div className="status-container">
        <div className="status-modal-close"></div>
        <div className="status-modal-date-text">対象日</div>
        <div className="status-modal-date-form">
          <DatePicker
            selected={stringToDate(datepickerDate)}
            onChange={date => date && handleDateFormChange(date, setDatepickerDate) }
            dateFormat="yy/MM/dd"
            calendarStartDay={1}
          />
        </div>
        <div className="status-modal-time-text">時刻</div>
        <div className="status-modal-time-form">
          <input type="time" defaultValue={formatInitialTime(new Date(date))} onChange={handleTimeFormChange}/>
        </div>
        <div className="status-modal-registration">
          <RippleButton
            width={'80px'}
            heihgt={'40px'}
            borderRadius={'8px'}
            onClick={registrationDate}
            effectSize={160}
            className='bk-secondary'
          >
            <span className="children">登録</span>
          </RippleButton>
        </div>
      </div>
    </div>
  );
};

export default TimecardStatus;